<template>
  <div v-for="(actionData, action) in actions" :key="action" class="col flex-grow-0 align-self-center px-0">
    <resource-action
      v-if="actionVisible(action)"
      :action="action"
      :action-data="actionData"
      :button-class="buttonClass"
      :model="model ?? {}"
      :options="options"
      :resource-type="resourceType"
      class="mx-2"
      show-name="true"
      @updatePicked="updatePicked"
    ></resource-action>
  </div>
</template>

<script>
import ResourceAction from '@kanrisha/components/Links/ResourceAction';

export default {
  components: {
    ResourceAction,
  },
  props: {
    actions: {
      type: Object,
      default: () => ({
        dashboard: { name: 'Dashboard', iconClass: 'bi bi-list-columns' },
        edit: { name: 'Bearbeiten', iconClass: 'bi bi-pencil-fill' },
        show: { name: 'Ansehen', iconClass: 'bi bi-eye-fill' },
        index: { name: 'Liste', iconClass: 'bi bi-list' },
      }),
    },
    buttonClass: { type: String, default: null },
    model: { type: Object, default: null },
    options: { type: Object, default: null },
    resourceType: { type: String, default: null },
    sourceAction: { type: String, default: null },
  },
  emits: ['updatePicked'],
  setup(props, { emit }) {
    const updatePicked = (model) => {
      emit('updatePicked', model);
    };

    const actionVisible = (action) => {
      if (!actionAvailable(action)) {
        return false;
      }

      return action !== props.sourceAction && (action === 'index' || action === 'dashboard' || props.model?.data.id);
    };

    const actionAvailable = (action) => {
      return props.model.meta.config.actions.models[action] ?? false;
    };

    return {
      actionAvailable,
      actionVisible,
      updatePicked,
    };
  },
};
</script>
